import React, { useState ,useCallback } from "react";
import { Grid, Icon, Loader } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { removeLineItem} from "../../actions";

function MerchForm1(props) {
  const dispatch = useDispatch();
  const [isRemoving, setIsRemoving] = useState(false);
  const {
    lineNumber,
    unitValue,
    commercialDescription,
    merchandiseId,
    invoiceItemIndex,
    countryOfOrigin,
    preference,
    invoiceId,
    isFormDisabled,
    activeAccordianIndex,
    commodityCode,
    totalLineItems,
    invoiceIndex,
    translate,
  } = props


  const   updateRemoveFlag = useCallback(
    () => {
      setIsRemoving(false);
    },
    [isRemoving] 
  )




  let counter =
    lineNumber < 10
      ? `00${lineNumber}`
      : lineNumber < 99
        ? `0${lineNumber}`
        : lineNumber;
  return (
    <Grid.Row
      style={{ paddingTop: "0px", paddingBottom: "0px" }}
      className="title"
    >

      <div className="stepNumber">
        <Icon
          name={activeAccordianIndex ? `minus circle` : `plus circle`}  >

        </Icon>
        <span>{counter}</span>
      </div>

      {activeAccordianIndex && <Grid.Column width={2}>
        {!isRemoving ? (
          <>
            {" "}
            {activeAccordianIndex === true &&


              (
                totalLineItems > 1 && 
                <span className="icon-item-delete">
                  <Icon
                    name="trash alternate outline"
                    onClick={() => {
                      if (
                        !window.confirm(
                          translate("R_U_SURE_REMOVE_ITEM",{ns:["default","lineItem"]}) +
                          counter
                        )
                      )
                        return;
                      setIsRemoving(true);
                      dispatch(
                        removeLineItem(
                          merchandiseId,
                          invoiceId,
                          invoiceIndex,
                          invoiceItemIndex,
                          totalLineItems,
                          updateRemoveFlag
                        )
                      );
                    }}
                    disabled={isFormDisabled || isRemoving}
                  />
                </span>
               )
               } 
          </>
        ) : (
          <span className="icon-item-deleteing">
            <Loader active size="tiny" />
          </span>
        )}
      </Grid.Column>}
      {!activeAccordianIndex && (
        <>


          <Grid.Column width={2} style={{ paddingTop: "6px" }}>
            <span title="Commodity Code" className="merch-accordian" disabled={isFormDisabled}>
              {commodityCode || ""}
            </span>
          </Grid.Column>


          <Grid.Column width={6} style={{ paddingTop: "6px" }} className="merch-accordian">
            <span title="Commercial Description" disabled={isFormDisabled}>
              {commercialDescription || ""}
            </span>
          </Grid.Column>


          <Grid.Column
            width={2} style={{ paddingTop: "6px" }}
          >
            <span title="Unit Value" className="merch-accordian" disabled={isFormDisabled}>
              {parseFloat(unitValue === "" ? "0.00" : unitValue).toFixed(2)}
            </span>
          </Grid.Column>

          <Grid.Column
            width={1} style={{ paddingTop: "6px" }}
          >
            <span title="Country Of Origin" className="merch-accordian" disabled={isFormDisabled}>
              {countryOfOrigin || ""}
            </span>
          </Grid.Column>

          <Grid.Column style={{ paddingTop: "6px" }}
            width={1}
          >
            <span title="Preference" className="merch-accordian" disabled={isFormDisabled}>
              {preference || ""}
            </span>
          </Grid.Column>

        </>
      )}
      {activeAccordianIndex && (
        <Grid.Column width={7} style={{ textAlign: "center" }}>


          {translate("MERCHANDISE",{ns:["default","lineItem"]})}

        </Grid.Column>
      )}
    </Grid.Row>
  );
}

export default React.memo(MerchForm1)